module.exports = __webpack_public_path__ + "img/no-documents.29423f0b.svg";